import request from './common/request'
import qs from 'qs'
import { SIMBART_MERCHANT_AD_CONFIG_URL, SIMBART_MERCHANT_ACTIVITY_COMPETITION_AD_URL } from './urls'
/**
 * 获取广告列表
 * @param {*} params
 * @returns
 */
async function query (params) {
  return request({
    url: `${SIMBART_MERCHANT_AD_CONFIG_URL}/query`,
    method: 'GET',
    params: params
  })
}

async function addAd (params) {
  return request({
    url: `${SIMBART_MERCHANT_AD_CONFIG_URL}/add`,
    method: 'POST',
    params: params
  })
}

async function deleteById (id) {
  return request({
    url: `${SIMBART_MERCHANT_AD_CONFIG_URL}/${id}`,
    method: 'DELETE'
  })
}

async function edit (params) {
  console.log(params)
  return request({
    url: `${SIMBART_MERCHANT_AD_CONFIG_URL}/edit`,
    method: 'POST',
    params: params
  })
}

async function enable (id) {
  return request({
    url: `${SIMBART_MERCHANT_AD_CONFIG_URL}/${id}/enable`,
    method: 'PUT'
  })
}

async function disable (id) {
  return request({
    url: `${SIMBART_MERCHANT_AD_CONFIG_URL}/${id}/disable`,
    method: 'PUT'
  })
}

// 获取活动下的所有比赛
async function competitionAddAd (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_AD_URL}/save`,
      method: 'POST',
      data: qs.stringify(params)
    }
  )
}

// 获取活动下的所有比赛
async function competitionQueryAd (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_AD_URL}/query`,
      method: 'GET',
      params
    }
  )
}
// 删除活动下指定广告
async function competitionDeleteAd (params) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_COMPETITION_AD_URL}/delete`,
      method: 'POST',
      data: qs.stringify(params)
    }
  )
}

export default {
  query,
  addAd,
  deleteById,
  edit,
  enable,
  disable,
  competitionQueryAd,
  competitionAddAd,
  competitionDeleteAd
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-ad.js